import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { RdsDataProductBannerComponent } from './data-product-banner.component';

@NgModule({
  imports: [CommonModule, FlexLayoutModule],
  exports: [RdsDataProductBannerComponent],
  declarations: [RdsDataProductBannerComponent],
})
export class RdsDataProductBannerModule {}
export * from './data-product-banner.component';
